@import "@SeemplicityDev/shared/src/design-system/styles/constants.scss";

.input-wrap-location-tree {
  .input-holder {
    padding-inline: var(--input-with-icon-padding) !important;
  }
  &.is-empty {
    .input-holder {
      padding-inline: var(--input-padding) !important;
    }
  }
}
